import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, meter, partCategory } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { QRCode } from "react-qrcode-logo";

import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader, formatNumber } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { PermissionChecker } from "../../components/PermissionChecker/index.jsx";

function MeterList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1,location_id: "",status:"" });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const [categories, setCategories] = useState([]);
  const [statuses, setStatuses] = useState(['Alarm','Warning','Normal']);
  const navigate = useNavigate();

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await meter.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }



  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }



  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  async function deleteData() {
    try {
      const response = await meter.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This meter has been deleted");

          setDeleteRow(null);
          await getData();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [

    {
      name: "Meter Name",
      selector: (row) => row.meter_name,
      minWidth: "150px",
    },
      {
        name: "Meter Type",
        selector: (row) => row.meter_type,
    },

    {
      name:"Asset",
      selector: (row) => row.asset?.asset_name,
    },
    {
      name: "Latest Reading",
      cell: (row) => {
        const reading = row.readings[0];
        if (!reading) return "No Reading";
        return <span>{reading.reading_value} {row.unit?.name}</span>;
      },
    },
    {
      name:"Status",
      cell: (row) => {
        const status = row.status;
        if(status === "no reading value" || status=='active') return <span className="badge">No Reading Value</span>;
        if(status === "no threshold set") return <span className="badge">No Threshold Set</span>;
        if(status === "alarm") return <span className="badge bg-danger">Alarm</span>;
        if(status === "warning") return <span className="badge bg-warning">Warning</span>;
        if(status === "normal") return <span className="badge bg-success">Normal</span>;
      },
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-outline-theme me-2"
            onClick={() => {
              navigate(`/meter/detail/${row.id}`);
            }}
          >
            View
          </button>

          <button
            className="btn btn-sm btn-outline-warning me-2"
            onClick={() => {
              navigate(`/meter/edit/${row.id}`);
            }}
          >
             <i className="fa fa-edit"></i>
          </button>

          <PermissionChecker permissions={["delete meter reading"]} hideIfNotAllowed>
          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => {
              showConfirmationDlg(row);
            }}
          >
     <i className="fa fa-trash"></i>
            </button>
            </PermissionChecker>
        </div>
      ),
    },
  ];

  const handleChangeLocationFilter = (location) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location ? location.id : "",
    }));
  };

  const handleChangeCategory = (id) => {
    setQuery((prev) => ({
      ...prev,
      page:1,
      category_id: id,
    }));
  };

  const handleChangeStatus = (status) => {
    setQuery((prev) => ({
      ...prev,
      page:1,
      status: status,
    }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take,query.status,query.location_id,query.category_id]);



  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await asset.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">METER</a>
            </li>
            <li className="breadcrumb-item active">METER LIST</li>
          </ul>

          <h1 className="page-header">Meter List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">

            <div className="col-sm-2 mb-2 mb-sm-0">
                <LocationFilter  onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-2 mb-2 mb-sm-0">
                <select
                  value={query.status}
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeStatus(e.target.value);
                  }}
                >
                  <option value="">
                    - Status -
                  </option>
                    {statuses.map((s) => (
                      <option value={s.toLowerCase()}>{s}</option>
                  ))}
                </select>
              </div>

              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/meter/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Meter <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>

                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        onRowClicked={(row) => navigate(`/meter/detail/${row.id}`)}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        onChangeRowsPerPage={(row)=>setQuery((prev)=>({...prev,page:1,take:row}))}
                        paginationTotalRows={query.totalData}
                        onChangePage={(page)=>setQuery((prev)=>({...prev,page:page}))}
                      />

                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Meter"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this meter{" "}
            <strong>{deleteRow.meter_name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default MeterList;
